/* eslint-disable react/destructuring-assignment */
import React from 'react';
import AccessTimeOutlinedIcon from '@material-ui/icons/AccessTimeOutlined';
import { green, yellow, red } from '@material-ui/core/colors';
import RenderTooltipCellByTypeView from '../../../shared/components/RenderTooltipCell';

export default function (t) {
  const textEllipsis = {
    maxWidth: '10rem',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };
  return [
    {
      title: t('general.student'),
      field: 'studentName',
      cellStyle: textEllipsis,
      render: (rowData, typeView) => (
        <RenderTooltipCellByTypeView
          field={rowData.studentName}
          typeView={typeView}
          rowData={rowData}
        />
      ),
    },
    { title: t('general.item'), field: 'levelOne' },
    {
      title: t('general.option'),
      field: 'note',
      cellStyle: textEllipsis,
      render: (rowData, typeView) => (
        <RenderTooltipCellByTypeView
          field={rowData.note}
          typeView={typeView}
          rowData={rowData}
        />
      ),
    },
    { title: t('general.date'), field: 'dateNote' },
    { title: t('general.hour'), field: 'hourNote' },
    {
      title: t('mnt_appointment.adjunct'),
      field: 'noteComplement',
      cellStyle: textEllipsis,
      render: (rowData, typeView) => (
        <RenderTooltipCellByTypeView
          field={rowData.noteComplement}
          typeView={typeView}
          rowData={rowData}
        />
      ),
    },
    {
      title: t('general.responsible'),
      field: 'responsible',
      cellStyle: textEllipsis,
      render: (rowData, typeView) => (
        <RenderTooltipCellByTypeView
          field={rowData.responsible}
          typeView={typeView}
          rowData={rowData}
        />
      ),
    },
    {
      title: t('general.employee'),
      field: 'employee',
      cellStyle: textEllipsis,
      render: (rowData, typeView) => (
        <RenderTooltipCellByTypeView
          field={rowData.employee}
          typeView={typeView}
          rowData={rowData}
        />
      ),
    },
    {
      title: t('mnt_appointment.synchronization'),
      field: 'dateSinc',
      cellStyle: textEllipsis,
      render: (rowData, typeView) => (
        <RenderTooltipCellByTypeView
          field={rowData.dateSinc}
          typeView={typeView}
          rowData={rowData}
        />
      ),
    },
    { title: t('mnt_appointment.source'), field: 'source' },
    {
      title: t('general.audit-status'),
      field: 'auditStatus',
    },
    {
      title: t('mnt_appointment.synchronization_time.title'),
      field: 'statusSinc',
      render: (rowData) => {
        if (rowData.statusSinc === 'OK') {
          return (
            <span
              className="tooltip-test"
              title={t('mnt_appointment.synchronization_time.less-than-1-hour')}
            >
              <AccessTimeOutlinedIcon style={{ color: green[500] }} />
            </span>
          );
        }
        if (rowData.statusSinc === 'ALER') {
          return (
            <span
              className="tooltip-test"
              title={t(
                'mnt_appointment.synchronization_time.between-1-and-4-hours'
              )}
            >
              <AccessTimeOutlinedIcon style={{ color: yellow[700] }} />
            </span>
          );
        }
        if (rowData.statusSinc === 'LATE') {
          return (
            <span
              className="tooltip-test"
              title={t(
                'mnt_appointment.synchronization_time.more-than-4-hours'
              )}
            >
              <AccessTimeOutlinedIcon style={{ color: red[500] }} />
            </span>
          );
        }
        return null;
      },
    },
    {
      title: t('general.readBy'),
      field: 'readingInformation',
      cellStyle: textEllipsis,
      render: (rowData, typeView) => (
        <RenderTooltipCellByTypeView
          field={rowData.readingInformation}
          typeView={typeView}
          rowData={rowData}
        />
      ),
    },
  ];
}
